import React, { useEffect, useState } from 'react';
import { Button, Drawer, Form, Modal, Spin } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { MERCHANT, ROOT } = useStore();
	const { merchantDetail } = MERCHANT;
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState();

	const handleSubmit = (data) => {
		setSaving(true);
		MERCHANT.EditMerchant({
			...data,
			id: merchantDetail.id,
			versionNo: merchantDetail.versionNo,
		})
			.then(() => {
				MERCHANT.merchantDetail = null;
				Notification.success({
					message: Message().CRUD.UPDATE('Merchant'),
				});
				closeModal();
			})
			.catch((e) => {
				const errorData = ROOT.assignErrorToInput(e);
				form.setFieldsValue({ error: errorData });
			})
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	const closeModal = () => {
		AUTH.stateList = [];
		AUTH.cityList = [];
		MERCHANT.merchantDetail = null;
		form.resetFields();
		setDisabled(true);
		onClose();
	};

	useEffect(() => {
		if (visible && merchantDetail) {
			form.setFieldsValue({
				merchantName: merchantDetail.merchantName,
				shortName: merchantDetail.shortName,
				email: merchantDetail.email,
				phoneNo: merchantDetail.phoneNo,
				eStateId: merchantDetail.eStateId,
				eCityId: merchantDetail.eCityId,
				pinCode: merchantDetail.pinCode,
				address: merchantDetail.address,
				description: merchantDetail.description,
			});
		}
	}, [visible, merchantDetail]);

	return (
		<Drawer
			title="Edit Merchant"
			onClose={closeModal}
			open={visible}
			destroyOnClose
			width={'43%'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditForm"
					>
						Update Merchant
					</Button>
					<Button
						key={2}
						style={{ marginLeft: '10px' }}
						onClick={closeModal}
					>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!merchantDetail}>
				<FormComponent
					id="EditForm"
					form={form}
					onFinish={handleSubmit}
					handleChange={handleChange}
				/>
			</Spin>
		</Drawer>
	);
});

export default EditComponent;
